import { render, staticRenderFns } from "./fourthClassifyDetail.vue?vue&type=template&id=08769c1d"
import script from "./fourthClassifyDetail.vue?vue&type=script&lang=js"
export * from "./fourthClassifyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports